import { createPopper } from '@popperjs/core'
import { ClassToggler } from '../classes/classToggler'
import ApplicationController from './application_controller'

//  TODO - Finish implementation for tooltips using tippy.js instead
//  NOTE - THIS CONTROLLER IS NOT READY AND IT SHOULDN"T BE USED YET
export default class extends ApplicationController {
  static targets = ['tooltip', 'item']
  doConnect() {
    this._popoverDisplayToggler = new ClassToggler(this.tooltipTarget, 'hidden')

    createPopper(this.itemTarget, this.tooltipTarget, {
      placement: 'left'
    })
    this._popoverDisplayToggler.addAllClasses()
  }

  show() {
    this._popoverDisplayToggler.removeAllClasses()
  }

  hide() {
    this._popoverDisplayToggler.addAllClasses()
  }

  toggle() {
    this._popoverDisplayToggler.toggleAllClasses()
  }
}
